import {EntityApiService, ApiClientService} from '@dofleini/security';

class SectionsIEApiService extends EntityApiService {

    addQuestion = (params) => {
      return ApiClientService.post(this.getPath(`/${params.sectionId}/question/add`), params);
    };

    updateQuestion = (params) => {
      return ApiClientService.patch(this.getPath(`/${params.sectionId}/question/${params?.questionId}/update`), params);
    };

    deleteQuestion = (params) => {
      return ApiClientService.delete(this.getPath(`/${params.sectionId}/question/${params?.questionId}/remove`), params);
    };

    changeQuestionOrder= ({sectionId, questionId, ...params}) => {
      return ApiClientService.patch(this.getPath(`/${sectionId}/question/${questionId}/order`), params);
    }
}

export default new SectionsIEApiService('/ms-core/api/ie-sections');
